import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en'
import zhHK from './zh-HK'
import { getLanguage } from '@/common/utils/i18n'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'zh-HK': { translation: zhHK },
    },
    lng: getLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n